/** Lead source options (aligned with lead create/edit modal). */
export const LEAD_SOURCE_OPTIONS: string[] = [
  'Channel Partner',
  'Conference',
  'Field Visit',
  'Google',
  'Instagram',
  'Lead Gen Tools',
  'Live Session',
  'Personal',
  'Referral',
  'LinkedIn',
  'Website',
  'WhatsApp',
  'Tina',
  'Intern',
  'Bot',
  'Chatbot',
  'Chat form',
  'Webform',
  'Landing Page',
  'Document scan',
  'Simulator',
  'Telephony',
  'Voice Agent',
  'Other',
];

/** Lead type options (aligned with lead create/edit modal). */
export const LEAD_TYPE_OPTIONS: string[] = ['New Lead', 'Cold Lead', 'Warm Lead', 'Hot Lead'];

export function normalizeFieldOptions(data: unknown): string[] {
  if (data == null) {
    return [];
  }
  if (Array.isArray(data)) {
    return data.map((v) => String(v)).filter((v) => v.length > 0);
  }
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) {
      return [];
    }
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map((v) => String(v)).filter((v) => v.length > 0);
        }
      } catch {
        /* fall through */
      }
    }
    return trimmed
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [String(data)];
}

export function isSelectLeadField(field: { type?: string } | null | undefined): boolean {
  const t = (field?.type || '').toLowerCase();
  return t === 'select' || t === 'dropdown';
}
